/* eslint-disable indent */
class TabbedContent {
	constructor(el) {
		this.el = el;
		this.clickedIndex = null;
		this.tabs = this.el.querySelectorAll('.block-tabbed-content__tab-button');
		this.tabContentContainer = this.el.querySelectorAll(
			'.block-tabbed-content__tab-content-container'
		);
		this.tabContent = this.el.querySelectorAll('.block-tabbed-content__tab-content');
		this.tabContentTitle = this.el.querySelectorAll('.block-tabbed-content__tab-content-title');
		this.tabContentWrapper = this.el.querySelectorAll(
			'.block-tabbed-content__tab-content-wrapper'
		);

		this.handleTabClick();
		this.handleAccordionClick();

		window.addEventListener('resize', () => {
			this.handleTabClick();
			this.handleAccordionClick();
		});

		this.setTabIndex();
		this.selectTabFromQueryParams();
		this.setHeightToTabs();
	}

	setBlockMinHeight = () => {
		if (window.innerWidth >= 1024) {
			const tabs = this.el.querySelector('.block-tabbed-content__tabs');
			this.style('min-height', tabs.height + 'px');
		}
	}

	selectTabFromQueryParams = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const tabParam = urlParams.get('tab');
		if (tabParam) {
			let tabToClick;
			if (window.innerWidth >= 1024) {
				tabToClick = this.el.querySelector(`[data-desktop-tab="${tabParam}"]`);
			} else {
				tabToClick = this.el.querySelector(`[data-mobile-tab="${tabParam}"]`);
			}

			if (tabToClick) {
				tabToClick.click();
			}
		}
	};

	setHeightToTabs = () => {
		if (window.innerWidth >= 1024) {
			const tabs = this.el.querySelector('.block-tabbed-content__tabs');
			const tabsHeight = tabs.offsetHeight;
			const tabContentBlockWrapper = this.el.querySelector('.block-tabbed-content__wrapper');
			const tabContentBlockWrapperHeight = tabContentBlockWrapper.offsetHeight;

			tabContentBlockWrapper.style.minHeight = `${tabsHeight + 88}px`;
		}
	};

	handleTabClick = () => {
		if (window.innerWidth >= 1024) {
			this.tabs.forEach((tab) => {
				tab.addEventListener('click', () => {
					this.clickedIndex =  tab;
					this.tabContentContainer.forEach((tabContent) => {
						if (tabContent.dataset.index === tab.dataset.index) {
							tabContent.classList.add('active');
							const links = tabContent.querySelectorAll('a');
							links.forEach((link, idx) => {
								link.setAttribute('tabindex', 0);
								if (idx === 0) {
									link.focus();
								}
							});
						} else {
							tabContent.classList.remove('active');
						}
					});
					this.tabs.forEach((t) => {
						const button = t;
						if (t.dataset.index !== tab.dataset.index) {
							t.classList.remove('active');
							button.setAttribute('aria-selected', 'false');
						} else {
							t.classList.add('active');
							button.setAttribute('aria-selected', 'true');
						}
					});
					window.scrollTo({
						top: this.tabContentWrapper.offsetTop + 286,
						behavior: 'smooth'
					});
					this.setHeightToTabs();
				});
			});

			if (this.clickedIndex !== null) {
				this.clickedIndex.click();
			}
		}
	};

	handleAccordionClick = () => {
		if (window.innerWidth < 1024) {
			this.tabContentContainer.forEach((tabContent) => {
				const button = tabContent.querySelector(
					'.block-tabbed-content__tab-content-subtitle--mobile'
				);
				button.addEventListener('click', () => {
					if (!tabContent.classList.contains('active')) {
						this.tabContentContainer.forEach((c) => {
							if (c.dataset.index !== button.dataset.index) {
								c.classList.remove('active');
							} else {
								c.classList.add('active');
							}
						});
					}
					window.scrollTo({
						top: button.offsetTop,
						behavior: 'smooth'
					});
				});
			});
		}
	};

	setTabIndex = () => {
		const wysiwygs = this.el.querySelectorAll('.wysiwyg');
		wysiwygs.forEach((wysiwyg, index) => {
			const links = wysiwyg.querySelectorAll('a');
			links.forEach((link) => {
				link.setAttribute('tabindex', -1);
			});
		});
	};
}

export default TabbedContent;
